<div class="position-relative">
    <overlay-spinner *ngIf="loading"></overlay-spinner>
    <div
        class="timeline-container"
        (pointerdown)="startDrag($event)"
        (pointermove)="onDrag($event)"
        (pointerup)="endDrag($event)"
        (pointercancel)="endDrag($event)"
    >
        <cdss-patient-overview-v2-timeline-card [timeline]="timeline" [type]="type" [day]="day" [patientId]="patientId" *ngFor="let day of days"></cdss-patient-overview-v2-timeline-card>
    </div>
</div>

